<template>
    <basic-modal @hide="close"
                 v-model="opened"
                 aria-label="New Wiki"
                 role="dialog"
    >
        <div slot="header">
            <basic-modal-close-button ref="closeButton"></basic-modal-close-button>
            <h3 class="modal-title">Update access link</h3>
        </div>
        <div class="alert alert-warning">
            Attention: this link will be valid for the specified term from today's date.
        </div>
        <div>
            <form action="#" @submit.stop.prevent="createLink">

                <div class="row margin-15-top">
                    <div class="col-sm-12">
                        <div>
                            <strong>Link expires in:</strong>
                            <select class="form-control" v-model="validityTerm">
                                <option :value="term.val" v-for="term in accessLinkPossibleTerms" :key="term.val">{{
                                        term.name
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div slot="footer">
            <button class="btn btn-mm btn-default" @click="close">Cancel</button>
            <button class="btn btn-mm btn-green" @click="createLink">Update</button>
        </div>
    </basic-modal>
</template>

<script>
    import BasicModal from '../../../../../vue/common_components/BasicModal.vue';
    import BasicModalCloseButton from '../../../../../vue/common_components/BasicModalCloseButton.vue';
    import PopupPromiseMixin from '../../../../../vue/mixins/PopupPromiseMixin';

    export default {
        name: 'UpdateAccessLinkPopup',
        mixins: [PopupPromiseMixin],
        components: {
            BasicModalCloseButton,
            BasicModal
        },
        data () {
            return {
                validityTerm: 14,
            };
        },
        computed: {
            firstFocusEl () {
                return this.$refs['name-input'];
            },
            accessLinkPossibleTerms () {
                return [
                    {
                        name: 'never',
                        val: null
                    },
                    {
                        name: '3 days',
                        val: 3
                    },
                    {
                        name: '1 week',
                        val: 7
                    },
                    {
                        name: '2 weeks',
                        val: 14
                    },
                    {
                        name: '1 month',
                        val: 30
                    },
                ];
            }
        },
        methods: {
            createLink () {
                this.save({
                    term_days: this.validityTerm
                });
            }
        }
    };
</script>
